import {checkIsEmpty} from '@/utils/util'

// 移除缓存
export function removeCache(key) {
  window.sessionStorage.removeItem(key);
}

// 设置缓存 字符串
export function setCache(key, value) {
  window.sessionStorage.setItem(key, value);
}

// 获取缓存 字符串
export function getCache(key) {
  var value = window.sessionStorage.getItem(key);
  return value;
}

// 设置缓存 json对象
export function setCacheObj(key, value) {
  window.sessionStorage.setItem(key, JSON.stringify(value));
}

// 获取缓存 json对象
export function getCacheObj(key) {
  var item = window.sessionStorage.getItem(key);
  if (!checkIsEmpty(item)) {
    return JSON.parse(item);
  }

  return null;
}

// 清除 sessionStorage
export function cacheClear() {
  window.sessionStorage.clear();
}






// WEBPACK FOOTER //
// ./src/utils/cache.js